import React from 'react';
import Button from './Button';
import SearchCriteria, { Criteria } from './SearchCriteria';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

export interface FormSearchProps<TFormState = Record<string, any>> {
    criteria: TFormState;
    onEdit?: () => void;
    label?: string;
    className?: string;
}

const FormSearch: React.FC<FormSearchProps> = ({
    criteria,
    onEdit,
    label = 'Edit Search',
    className = 'edit-search drawer-head',
}) => {
    const crit = formStateToSearchCriteria(criteria);

    const handleEdit = (): void => {
        if (onEdit) onEdit();
    };

    return (
        <div className={className}>
            <Button onClick={handleEdit}>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
                &nbsp; {label}
            </Button>
            <SearchCriteria criteria={crit} />
        </div>
    );
};

function formStateToSearchCriteria<TFormState extends Record<string, any>>(state: TFormState): Criteria {
    const record = {} as Criteria;
    Object.keys(state).forEach(key => {
        const prop = state[key];
        if (prop.val !== undefined && prop.val !== '' && prop.val !== false) {
            record[key] = prop;
        }
    });
    return record;
}

export default FormSearch;
